let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4JkkU"), load("hmhwB"), load("eDsoF"), load("i0ovk"), load("ffEVr"), load("zogKQ"), load("kZjBp")]).then(() => parcelRequire('1xLOH'));